module.exports = __webpack_public_path__ + "img/Fitrat.1752b98e.jpg";